module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image44.844a355c.webp";